import React from "react";

import CopyToClipboardIconWrapper from "./CopyToClipboardIconWrapper";
import ImageComponent from "./ImageComponent";
import placeholderImage from "../../assets/placeholder-no-image-available.png";
import { getFontAwesomeIcon } from "../../utils";

interface ShipmentItem {
	id: string;
	image: string;
	productName: string;
	partNumber: string;
	sku: string;
	upc: string;
	units: number;
	serialNumbers: string[];
	itemsTitle?: string;
}

interface ShipmentItemProps {
	shipmentItem: ShipmentItem;
	toggleShipmentItem: (id: string) => void;
	openShipmentItems: string[];
	onlySerialNumbers?: boolean;
}

interface ShipmentItemFieldBlueprint {
	id: string;
	label: string;
	valueKey: ShipmentItemKey;
}

type ShipmentItemKey = "partNumber" | "sku" | "upc" | "units" | "image";

const shipmentItemFieldsConfig: ShipmentItemFieldBlueprint[] = [
	{ id: "4", label: "Units", valueKey: "units" },
	{ id: "1", label: "Part Number", valueKey: "partNumber" },
	{ id: "2", label: "SKU", valueKey: "sku" },
	{ id: "3", label: "UPC", valueKey: "upc" },
];

const ShipmentItem: React.FC<ShipmentItemProps> = React.memo(
	({
		shipmentItem,
		toggleShipmentItem,
		openShipmentItems,
		onlySerialNumbers,
	}) => {
		const chevronColor = "#535662";
		const iconContainerBorderColor = "#535662";
		const shipmentItemHeaderClassNames = `flex hover:cursor-pointer items-center gap-2 border-b-1 border-tableLightGray py-2`;
		const shipmentItemHeaderIconClassNames = `border-1 h-full px-1 border-${iconContainerBorderColor} rounded text-${chevronColor}`;
		const imageClassNames = `border-1 border-tableLightGray rounded mr-6 size-2 w-12 h-12`;
		const shipmentItemMapClassNames = "flex gap-8";
		const openTableBackgroundClassesNames = "bg-tableLightGray";
		const nestedTableRowContainerClassNames =
			"flex justify-end items-center relative w-40";
		const copyWrapperContainer = "absolute left-10 top-2";
		const nestedRowClassNames = "border-b-tableLightGray border-b-2 m-20";
		const nestedTdClassNames = "flex items-center px-20";
		const nestedTableHeaderClassNames = "ml-4 flex  w-1/5 justify-between";

		return (
			<div key={shipmentItem.id}>
				<div
					className={shipmentItemHeaderClassNames}
					onClick={() => toggleShipmentItem(shipmentItem.id)}
				>
					<div className={shipmentItemHeaderIconClassNames}>
						{getFontAwesomeIcon(
							openShipmentItems.includes(shipmentItem.id)
								? "chevronUp"
								: "chevronDown",
							"regular"
						)}
					</div>
					<div className={imageClassNames}>
						<ImageComponent
							// TODO: once we have the URL in the date add it in instead of the empty string
							imageUrl={placeholderImage}
							altText={""}
						/>
					</div>
					<div className={shipmentItemMapClassNames}>
						{shipmentItemFieldsConfig.map((field) => (
							<p key={field.id}>
								{field.label}: {shipmentItem[field.valueKey]}
							</p>
						))}
						<h2>{shipmentItem.productName}</h2>
					</div>
				</div>
				{openShipmentItems.includes(shipmentItem.id) && (
					<div className="overflow-x-auto">
						<table className="table">
							<thead className={openTableBackgroundClassesNames}>
								<tr className="border-b-0">
									<th className={nestedTableHeaderClassNames}>
										<div>#</div>
										<div className="flex">
											{shipmentItem.itemsTitle}
											<div>
												{/* <CopyToClipboardIconWrapper
													trackingNumber={""}
													withText
													copyText="Copy All"
													lastCopiedTrackingNumber={
														""
													}
													setLastCopiedTrackingNumber={function (
														trackingNumber: string
													): void {
														throw new Error(
															"Function not implemented."
														);
													}}
												/> */}
											</div>
										</div>
									</th>
								</tr>
							</thead>
							<tbody>
								{shipmentItem.serialNumbers.map(
									(serialNumber, index) => (
										<tr
											className={nestedRowClassNames}
											key={index}
										>
											<td className={nestedTdClassNames}>
												<div>{index + 1}</div>
												<div
													className={
														nestedTableRowContainerClassNames
													}
												>
													<div
														className={
															copyWrapperContainer
														}
													>
														{/* <CopyToClipboardIconWrapper
															trackingNumber={
																"1Z175W8RD379281896"
															}
															lastCopiedTrackingNumber={
																""
															}
															iconStyles={""}
															setLastCopiedTrackingNumber={function (
																trackingNumber: string
															): void {
																throw new Error(
																	"Function not implemented."
																);
															}}
														/> */}
													</div>
													<div>{serialNumber}</div>
												</div>
											</td>
										</tr>
									)
								)}
							</tbody>
						</table>
					</div>
				)}
			</div>
		);
	}
);

export default ShipmentItem;
